import { useState } from 'react';

import P from 'prop-types';
import { Api } from '../../../../services/api';

export const CanvaEditUser = ({ user, updateList }) => {
  const [loading, setloading] = useState(false);

  const [requisicaoFeita, setRequisicaoFeita] = useState(false);

  const [isError, setIsError] = useState(true);

  // eslint-disable-next-line no-unused-vars
  const [input, setInput] = useState({
    nome: user.nome,
    nick: user.nick,
    senha: '',
  });

  const clearCampos = () => {
    setloading(false);
    setRequisicaoFeita(false);
    setIsError(true);
    setInput({
      nome: user.nome,
      nick: user.nick,
      senha: '',
    });
  };

  const updateUser = async () => {
    setloading(true);
    try {
      await Api.put(`/user/update/${user.id}`, {
        nome: input.nome,
        nick: input.nick,
        senha: input.senha,
      });
      setIsError(false);
    } catch {
      setIsError(true);
    } finally {
      setRequisicaoFeita(true);
      setloading(false);
      updateList();
    }
  };

  const handleClick = () => {
    updateUser();
  };

  const handleChange = (e) => {
    const { value, name } = e.target;

    setInput({
      ...input,
      [name]: value,
    });
  };

  return (
    <>
      <button
        className="btn btn-outline-success"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target={`#canvaEditUserSelected${user.id}`}
        aria-controls={`canvaEditUserSelected${user.id}`}
        onClick={clearCampos}
      >
        Alterar
      </button>

      <div
        className="offcanvas offcanvas-end"
        data-bs-scroll="true"
        data-bs-backdrop="false"
        tabIndex="-1"
        id={`canvaEditUserSelected${user.id}`}
        aria-labelledby="offcanvasScrollingLabel"
        style={{ width: '750px' }}
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasScrollingLabel">
            Editar usuário
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={clearCampos}
          ></button>
        </div>
        <div className="offcanvas-body">
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <div className="nav-link active" aria-current="page">
                Dados Usuário
              </div>
            </li>
          </ul>

          <div className="mt-3">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              Nome
            </label>
            <input
              name="nome"
              type="text"
              className="form-control"
              id="exampleFormControlInput1"
              placeholder="Nome completo do usuário"
              value={input.nome}
              onChange={handleChange}
            />
          </div>

          <div className="mt-3">
            <label htmlFor="exampleFormControlInput1" className="form-label" disabled={true}>
              Usuário
            </label>
            <input
              name="nick"
              type="text"
              className="form-control"
              id="exampleFormControlInput1"
              placeholder="Usuário"
              value={input.nick}
              onChange={() => 0}
              disabled={true}
            />
          </div>

          <div className="mt-3">
            <label htmlFor="exampleFormControlInput1" className="form-label" disabled={true}>
              Alterar senha
            </label>
            <input
              name="senha"
              type="password"
              className="form-control"
              id="exampleFormControlInput1"
              placeholder="Digite a nova senha do usuário"
              value={input.senha}
              onChange={handleChange}
            />
          </div>

          <div className="input-group mt-4">
            <label className="input-group-text" htmlFor="inputGroupSelect01">
              Acesso
            </label>
            <select className="form-select" id="inputGroupSelect01">
              <option value="1">Admin</option>
              <option value="2">Comum</option>
            </select>
          </div>

          {requisicaoFeita && (
            <div className="mt-2" onClick={() => setIsError((e) => !e)}>
              {!isError ? (
                <span style={{ color: '#047235' }}>Foi atualizado o usuário com sucesso!</span>
              ) : (
                <span style={{ color: 'red' }}>Ocorreu um erro ao atualizar o usuário!</span>
              )}
            </div>
          )}

          <div className="row mt-3">
            <div className="col-2">
              <button className="btn btn-success w-100" onClick={handleClick}>
                {!loading ? (
                  <span>Alterar</span>
                ) : (
                  <div className="spinner-border text-light spinner-border-sm" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                )}
              </button>
            </div>
            <div className="col-10"></div>
          </div>
        </div>
      </div>
    </>
  );
};

CanvaEditUser.propTypes = {
  user: P.object,
  updateList: P.func,
};
